import React from 'react';
import { levelConfig } from '../../data/portfolioData';
import { Coins, Trophy, MapPin, Pause, Play, SkipForward } from 'lucide-react';

export const HUD = ({ 
  currentLevel, 
  coinsCollected, 
  totalCoins, 
  itemsUnlocked,
  totalItems,
  isPaused,
  onPause,
  onResume,
  onSkipToResume 
}) => {
  const level = levelConfig[currentLevel - 1];
  
  return (
    <div className="absolute top-0 left-0 right-0 z-50 p-2 md:p-4 retro-ui hud-mobile" data-testid="game-hud">
      {/* Mario HUD bar */}
      <div className="bg-gradient-to-r from-[#fddc70] to-[#f2b418] rounded-none border-2 md:border-4 border-black p-2 md:p-3 shadow-lg">
        <div className="flex flex-wrap items-center justify-between gap-2 md:gap-4">
          {/* Level Info */}
          <div className="flex items-center gap-2 md:gap-3">
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-xl bg-gradient-to-br from-sky-400 to-sky-600 flex items-center justify-center shadow-lg">
              <MapPin className="w-4 h-4 md:w-5 md:h-5 text-white" />
            </div>
            <div className="level-info">
              <p className="text-xs text-white/70 font-medium">LEVEL {currentLevel}</p>
              <p className="text-sm font-bold text-white" data-testid="level-name">{level?.name}</p>
            </div>
          </div>
          
          {/* Stats */}
          <div className="flex items-center gap-3 md:gap-6">
            {/* Coins */}
            <div className="flex items-center gap-1 md:gap-2">
              <div className="w-6 h-6 md:w-8 md:h-8 rounded-lg bg-gradient-to-br from-yellow-400 to-amber-500 flex items-center justify-center shadow-md">
                <Coins className="w-3 h-3 md:w-4 md:h-4 text-white" />
              </div>
              <div>
                <p className="text-xs text-white/70">Coins</p>
                <p className="text-xs md:text-sm font-bold text-yellow-400" data-testid="coins-count">
                  {coinsCollected}/{totalCoins}
                </p>
              </div>
            </div>
            
            {/* Items Unlocked */}
            <div className="flex items-center gap-1 md:gap-2">
              <div className="w-6 h-6 md:w-8 md:h-8 rounded-lg bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-md">
                <Trophy className="w-3 h-3 md:w-4 md:h-4 text-white" />
              </div>
              <div>
                <p className="text-xs text-white/70">Unlocked</p>
                <p className="text-xs md:text-sm font-bold text-purple-400" data-testid="items-count">
                  {itemsUnlocked}/{totalItems}
                </p>
              </div>
            </div>
          </div>
          
          {/* Controls */}
          <div className="flex items-center gap-1 md:gap-2">
            <button
              onClick={isPaused ? onResume : onPause}
              className="w-8 h-8 md:w-10 md:h-10 rounded-xl bg-red-600 hover:bg-red-700 flex items-center justify-center transition-colors border-2 border-black"
              data-testid="pause-btn"
            >
              {isPaused ? (
                <Play className="w-4 h-4 md:w-5 md:h-5 text-white" />
              ) : (
                <Pause className="w-4 h-4 md:w-5 md:h-5 text-white" />
              )}
            </button>
            
            <button
              onClick={onSkipToResume}
              className="px-2 md:px-3 h-8 md:h-10 rounded-xl bg-rose-500/80 hover:bg-rose-500 flex items-center gap-1 transition-colors text-white text-xs md:text-sm font-medium"
              data-testid="skip-btn"
            >
              <SkipForward className="w-3 h-3 md:w-4 md:h-4" />
              <span className="hidden sm:inline">Skip</span>
            </button>
          </div>
        </div>
        
        {/* Progress bar */}
        <div className="mt-2 md:mt-3 h-2 bg-white/10 rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-sky-400 to-purple-500 transition-all duration-500 rounded-full"
            style={{ width: `${(currentLevel / levelConfig.length) * 100}%` }}
            data-testid="progress-bar"
          />
        </div>
      </div>
      
      {/* Controls hint - hide on mobile, show on desktop */}
      <div className="mt-2 text-center hidden md:block">
        <p className="text-xs text-white/50 bg-black/20 backdrop-blur-sm rounded-lg px-3 py-1 inline-block">
          Use <span className="text-white/80 font-mono">← → or A D</span> to move, <span className="text-white/80 font-mono">↑ W Space</span> to jump
        </p>
      </div>
    </div>
  );
};

export default HUD;
